import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/lib/Alert';

export default function Toast({ children, ...rest }) {
  return <Alert {...rest}>{children}</Alert>;
}

Toast.propTypes = {
  children: PropTypes.node.isRequired,
};
